import React, { useContext, useState, useEffect, useMemo } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';

import { ResumoAnoMes, ValorTotalAno, OrcadoAnoMes } from '@app/api/ordemInvestimento';

interface FormResumoAnoMesProjetoProps {
  resultTableAnoMes: OrcadoAnoMes;
  resumoAno: ResumoAnoMes[];
  projetoId: string;
}

const { Panel } = Collapse;

const FormTableOrcadoAnoProjeto = (props: FormResumoAnoMesProjetoProps) => {
  const { resumoAno, projetoId, resultTableAnoMes } = props;

  const [resumoHeader, setResumoHeader] = useState<string>();
  const [valorTotal, setValorTotal] = useState<string>();
  const [anoAtual, setAnoAtual] = useState<string>();
  const [planilhaId, setPlanilhaId] = useState<string>();
  const [valoresTotaisPorAno, setValoresTotaisPorAno] = useState<ValorTotalAno[]>();

  useEffect(() => {
    const getData = async () => {
      if (resultTableAnoMes && resultTableAnoMes.dataAprovacao) {
        let header =
          resultTableAnoMes.numero + ' - ' + resultTableAnoMes.revisao + ' - ' + resultTableAnoMes.dataAprovacao;
        setResumoHeader(header);
        setPlanilhaId(resultTableAnoMes.planilhaId);
        setValoresTotaisPorAno(resultTableAnoMes.valorTotalCurrencyArray);
      }
    };

    getData();
  }, [resumoAno]);

  const columsTest = () => {
    const colluns = [];

    let col = [];

    colluns.push(
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'oi',
        width: '2%',
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
      }     
    );

    if (valoresTotaisPorAno && valoresTotaisPorAno.length > 0) {
      for (var j = 0; j < valoresTotaisPorAno.length; j++) {
        colluns.push({
          title: `${valoresTotaisPorAno[j].ano}`,
          dataIndex: `${valoresTotaisPorAno[j].ano}`,
          width: '',
          children: [
            {
              title: `${valoresTotaisPorAno[j].valorTotalCurrency}`,
              dataIndex: `${valoresTotaisPorAno[j].ano}`,
            },
          ],
        });
      }
    }

    return colluns;
  };

  let customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'oi',
        width: '2%',
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
      },
      // {
      //   title: 'Anos',
      //   dataIndex: 'valor',
      //   children: [
      //     {
      //       colunasValor,
      //     },
      //   ],
      // },
    ] as InlineEditColumnProps<ResumoAnoMes>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo orçado Ano" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                planilhaId && (
                  <Button
                    title="CONSULTAR DISTRIBUIÇÃO DO ANO ATUAL"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/moduloOrcado/planilhaOrcadoEconomicoAnoMes/detail/${planilhaId}`;
                    }}
                  />
                ),
              ]}>
              <Row>
                {resumoHeader && (
                  <FormInput
                    label="Planilha ciclo orçamentário Atual"
                    name="numero"
                    value={resumoHeader || ''}
                    span={3}
                    disabled
                  />
                )}
              </Row>
              <Row>
                <FormText label="" name="v" />
              </Row>
              <Row>
                <Table className="tabelaOrcado" rowKey="index" columns={columsTest()} dataSource={resumoAno || []} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableOrcadoAnoProjeto;
